import { Checkbox, CheckboxGroup } from '@globalmed/atlas-ui';
import { useState } from 'react';
import styles from './FormBuilderPreviewCheckbox.module.css';
import { TFormBuilderCheckboxField } from '@/types';

type TProps = {
  field: TFormBuilderCheckboxField;
};

/**
 * Preview component for checkbox field in form builder
 * @param props - Component props
 * @param props.field - Checkbox field data to preview
 * @returns Form builder checkbox preview component
 */
export const FormBuilderPreviewCheckbox = ({ field }: TProps) => {
  const [values, setValues] = useState<string[]>([]);
  return (
    <CheckboxGroup
      className={styles.container}
      label={field.label}
      checkedValues={values}
      onChangeValues={setValues}
      required={field.required}
    >
      {field.options.map(({ id, value }) => (
        <Checkbox
          key={id}
          className={styles.checkboxLabel}
          sx={{ marginTop: '2px' }}
          value={id}
          label={value}
        />
      ))}
    </CheckboxGroup>
  );
};
